import { OperationResult } from '@vp/common/core/OperationResult';
import { RemoveMediaDto } from '@vp/manager/gallery/core/dto/RemoveMediaDto';
import { UploadMediaDto } from '@vp/manager/gallery/core/dto/UploadMediaDto';
import { GalleryManagerUploadHandle } from '@vp/manager/gallery/core/interface/GalleryManagerUploadHandle';
import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';

export abstract class GalleryManagerPort {
  abstract upload(dto: UploadMediaDto): GalleryManagerUploadHandle;
  abstract remove(dto: RemoveMediaDto, controller?: AbortController): Promise<OperationResult>;
  abstract makeLive(photoId: string, controller?: AbortController): Promise<OperationResult>;
  abstract makeStatic(photoId: string, controller?: AbortController): Promise<OperationResult>;
  abstract getPhotoOfActiveProfileBy(id: string): ProfilePhotoModel;
  abstract hasPhotoAnimationAttempts(): boolean;
}
